import { GigLocationFieldFragment, Location } from "gql-gen";

// IMPORTANT: Since this record will have different UUIDs in different environments,
//            we have to use the `externalId` to check for equality.
export const NO_LOCATION: GigLocationFieldFragment["location"] = {
  __typename: "Location",
  id: "<ignored>",
  externalId: "1",
  name: "No location",
  address: "No location",
  latitude: undefined,
  longitude: undefined,
  addressJson: [],
};

export const isNoLocation = (location?: Pick<Location, "externalId" | "latitude" | "longitude">) =>
  location ? location.externalId === NO_LOCATION.externalId || (!location.latitude && !location.longitude) : false;
